module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"Mi selección":"Mi selección"},"en":{},"ca":{"Mi selección":"La meva selecció"}}')
  delete Component.options._Ctor
}
